/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-select/webhook-form-select.component.scss */
.ant-input-clear-icon {
  margin-right: 6px;
  cursor: pointer;
}
/*# sourceMappingURL=webhook-form-select.component.css.map */
